"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
require("./styles/application.scss");
require("./styles/parking.scss");
function Parking(_a) {
    var userManager = _a.userManager;
    var _b = (0, react_1.useState)(new Date()), selectedStartDate = _b[0], handleStartDateChange = _b[1];
    var _c = (0, react_1.useState)(new Date()), selectedEndDate = _c[0], handleEndDateChange = _c[1];
    var _d = (0, react_1.useState)(''), license = _d[0], setLicense = _d[1];
    var _e = (0, react_1.useState)(userManager.unit), unit = _e[0], setUnit = _e[1];
    var _f = (0, react_1.useState)(''), make = _f[0], setMake = _f[1];
    var _g = (0, react_1.useState)(''), color = _g[0], setColor = _g[1];
    var _h = (0, react_1.useState)(userManager.email), email = _h[0], setEmail = _h[1];
    var _j = (0, react_1.useState)(false), thanks = _j[0], setThanks = _j[1];
    var _k = (0, react_1.useState)(''), errorMessage = _k[0], setErrorMessage = _k[1];
    var useStyles = (0, makeStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
        root: {
            '& .MuiTextField-root': {
                margin: theme.spacing(1),
                width: '100%',
            },
        },
    }); });
    var styleProps = { backgroundColor: '#f37f30' };
    var classes = useStyles(styleProps);
    var handleNativeStartDateChange = function (date) {
        var startDate = new Date("".concat(date, "T01:00:00-05:00"));
        handleStartDateChange(startDate);
    };
    var handleNativeEndDateChange = function (date) {
        var endDate = new Date("".concat(date, "T01:00:00-05:00"));
        handleEndDateChange(endDate);
    };
    var register = function (e) {
        e.preventDefault();
        var formData = new FormData();
        formData.append('parking[start_date]', String(selectedStartDate));
        formData.append('parking[end_date]', String(selectedEndDate));
        formData.append('parking[license]', String(license));
        formData.append('parking[unit]', String(unit));
        formData.append('parking[make]', String(make));
        formData.append('parking[color]', String(color));
        formData.append('parking[contact]', String(email));
        userManager.visitorParking(formData)
            .then(function (response) {
            if (response.success === true) {
                setThanks(true);
            }
            else if (response.error) {
                setErrorMessage(response.error);
            }
        });
    };
    return (react_1.default.createElement("div", null,
        thanks && (react_1.default.createElement("div", { className: "section flex-grow" },
            react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12, className: "center" },
                    react_1.default.createElement("h4", { className: "center" }, "Thank you"),
                    react_1.default.createElement("p", { className: "center" },
                        "Thank you!",
                        '  ',
                        react_1.default.createElement("span", { role: "img", "aria-label": "" }, "\uD83D\uDE99"),
                        "The vehicle has been registered. If you receive a ticket in error please contact the property manager.",
                        '  '))))),
        !thanks && (react_1.default.createElement("form", { className: classes.root, noValidate: true, autoComplete: "off", onSubmit: register },
            react_1.default.createElement("div", { className: "section flex-grow" },
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement("h4", { className: "center" }, "Register a Vehicle"),
                        errorMessage !== '' && (react_1.default.createElement(material_1.Alert, { severity: "error" },
                            react_1.default.createElement(material_1.AlertTitle, null, "Error"),
                            errorMessage))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.TextField, { id: "start", label: "Start Date", type: "date", defaultValue: selectedStartDate, onChange: function (e) { return handleNativeStartDateChange(e.target.value); }, InputLabelProps: {
                                shrink: true,
                            } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.TextField, { id: "end", label: "End Date", type: "date", defaultValue: selectedEndDate, onChange: function (e) { return handleNativeEndDateChange(e.target.value); }, InputLabelProps: {
                                shrink: true,
                            } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.TextField, { id: "license", label: "License Plate", style: { width: '100%' }, value: license, onChange: function (e) { return setLicense(e.target.value); } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.TextField, { id: "unit", label: "Unit Number", style: { width: '100%' }, value: unit, onChange: function (e) { return setUnit(e.target.value); } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.TextField, { id: "make", label: "Vehicle Make", style: { width: '100%' }, value: make, onChange: function (e) { return setMake(e.target.value); } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.TextField, { id: "color", label: "Vehicle Colour", style: { width: '100%' }, value: color, onChange: function (e) { return setColor(e.target.value); } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.TextField, { id: "email", label: "Email or Phone Number", style: { width: '100%' }, value: email, onChange: function (e) { return setEmail(e.target.value); } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12, className: "center" },
                        react_1.default.createElement(material_1.Button, { variant: "contained", type: "submit", sx: {
                                backgroundColor: '#f37f30',
                                color: 'white',
                                marginBottom: '20px',
                            }, endIcon: react_1.default.createElement(material_1.Icon, null, "directions_car") }, "Register"))))))));
}
exports.default = Parking;
